import { cn } from "@productlane/lib/src/browser"

import { subtleSurfaceRing } from "./surface"

// A status group on the portal: a gray card holding its header and a white panel of rows.
export const portalGroupCardClass = cn(
	"rounded-xl bg-gray-100/70 p-1 dark:bg-gray-950",
	subtleSurfaceRing,
)

// The header sits inside the card, so it drops its own fill, gradient,
// sticky pin and mobile full-bleed.
export const portalGroupHeaderClass =
	"static my-0 rounded-none bg-transparent md:rounded-none px-2.5 py-2 backdrop-blur-none max-md:mx-0 max-md:px-2.5 dark:bg-transparent dark:md:shadow-none"
export const portalGroupHeaderStyle = { backgroundImage: "none" }

// The docs AI chat input card's surface, with a lighter lift for a list.
export const portalGroupPanelClass = cn(
	"divide-y divide-gray-100 overflow-hidden rounded-lg bg-white dark:divide-white/[0.05] dark:bg-gray-850",
	subtleSurfaceRing,
	"shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_1px_2px_rgba(15,17,21,0.04),0_6px_14px_-12px_rgba(15,17,21,0.18)]",
	"dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.04),0_1px_2px_rgba(0,0,0,0.5)]",
)
